import { ConverterLayout, layoutStyles } from '../converter-layout/converter-layout';

const FORMATS = ['stl', 'obj', 'glb', 'gltf', 'ply', '3mf'];

function parseSlug(slug: string | undefined): { from: string; to: string } {
    if (slug) {
        // Format hub ({ext}-converter): from = the hub's format, to = a sensible default.
        const hub = slug.match(/^([a-z0-9]+)-converter$/);
        if (hub && FORMATS.includes(hub[1])) {
            return { from: hub[1], to: hub[1] === 'glb' ? 'gltf' : 'glb' };
        }
        const m = slug.match(/^convert-([a-z0-9]+)-to-([a-z0-9]+)$/);
        if (m && FORMATS.includes(m[1]) && FORMATS.includes(m[2])) {
            return { from: m[1], to: m[2] };
        }
    }
    return { from: 'stl', to: 'obj' };
}

// SSR-safe static UI shell that mirrors the symmetric layout of the real
// editor. No imports that touch WebGL — crawlers and slow-JS browsers
// see the full layout instead of a "Loading tool…" spinner.
export default function Model3dConverterShell({ feature }: { feature?: string }) {
    const { from, to } = parseSlug(feature);
    const placeholder = (label: string) => (
        <div className={layoutStyles.area}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', color: '#64748b', minHeight: 320 }}>
            <div>
                <div style={{ fontSize: '2.5rem', opacity: 0.4 }}>🧊</div>
                <div style={{ marginTop: '0.5rem' }}>{label}</div>
            </div>
        </div>
    );
    return (
        <ConverterLayout
            toolbar={<>
                <div className={layoutStyles.formatField}>
                    <label>From format</label>
                    <select defaultValue={from} disabled>
                        {FORMATS.map(f => <option key={f} value={f}>{f.toUpperCase()}</option>)}
                    </select>
                </div>
                <div className={layoutStyles.formatField}>
                    <label>To format</label>
                    <select defaultValue={to} disabled>
                        {FORMATS.map(f => <option key={f} value={f}>{f.toUpperCase()}</option>)}
                    </select>
                </div>
            </>}

            inputLabel={`Input (${from.toUpperCase()})`}
            inputArea={placeholder('Choose a 3D model file to convert')}
            inputActions={
                <label className={layoutStyles.fileDrop}>
                    📂 Choose 3D file
                </label>
            }

            outputLabel={`Output (${to.toUpperCase()})`}
            outputArea={placeholder('3D preview will appear here')}
            outputActions={
                <button className={`${layoutStyles.iconBtn} ${layoutStyles.iconBtnPrimary}`} disabled>
                    ⬇ Download .{to}
                </button>
            }

            primaryAction={
                <button className={layoutStyles.primaryBtn} disabled>
                    Loading three.js…
                </button>
            }
        />
    );
}
